import {useState} from 'react';

export function useForceUpdate() {
  const [, setCounter] = useState(0);
  return () => {
    setCounter((x) => x + 1);
  };
}
